export default __webpack_public_path__ + "starry_night.png";